import { CollectionFields } from '@boss/types/corporate-jobs';

const getPhotoCollectionProps = (
  entry: CollectionFields,
): {
  images: {
    src: string;
    alt: string;
  }[];
} => {
  const { entries } = entry;

  return {
    images: entries.map(entry => {
      return { src: entry.image.file?.url, alt: entry.altText ?? entry.image.title };
    }),
  };
};

export default getPhotoCollectionProps;
